import { SelectItem } from 'primeng/api';
import { ProviderAccountPgpDTO } from '@mynexus/mynexus-ui-lib';
import { Component, Output, EventEmitter, Input, SimpleChanges, OnChanges } from '@angular/core';
import { ListboxClickEvent } from 'primeng/listbox';

@Component({
    selector: 'app-service-provider-select-address',
    templateUrl: './service-provider-select-address.component.html',
    styleUrls: ['./service-provider-select-address.component.scss'],
    standalone: false
})
export class ServiceProviderSelectAddressComponent implements OnChanges {
  @Input() label = '';
  @Input() providers: ProviderAccountPgpDTO[] = [];
  @Input() isExternalUser = false;
  @Input() isAcceptingCare = false;
  @Input() isLoadingProviders = false;
  @Output() selectionChange = new EventEmitter<any>();

  searchInput: string;
  availableProviders: any;
  providersSearch: SelectItem[] = [];
  isAcceptCareView: boolean;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.providers?.currentValue?.length) {
      this.availableProviders = this.isAcceptingCare
        ? this.buildProviderSelectItemListForExternalUser()
        : this.buildProviderSelectItemList();
      this.providersSearch = this.availableProviders;
    }
  }

  filterChanged(filterText: string) {
    const MIN_FILTER_LENGTH = 3;

    this.providersSearch =
      filterText && filterText.length >= MIN_FILTER_LENGTH
        ? this.filterProviderList(filterText)
        : this.availableProviders;
  }

  resetSearch() {
    this.searchInput = '';
    this.filterChanged(this.searchInput);
  }

  providerListBoxClick(event: ListboxClickEvent) {
    const selectedOption = event.option as SelectItem<{ currentIndex: number }>;
    const selectedIndex = selectedOption?.value?.currentIndex;

    if (typeof selectedIndex === 'number' && this.providers[selectedIndex]) {
      this.selectionChange.emit(this.providers[selectedIndex]);
    }
  }

  private filterProviderList(filterText: string) {
    const pattern = / +(?= )/g;

    if (!this.availableProviders) {
      return;
    }

    return this.availableProviders.filter(dataset =>
      dataset.label
        .toLocaleLowerCase()
        .replace(pattern, '')
        .indexOf(filterText.toLocaleLowerCase().replace(pattern, '').trim()) > -1
      || dataset.value.npi?.toString().indexOf(filterText.toLocaleLowerCase().trim()) > -1
    );
  }

  private buildProviderSelectItemList() {
    return this.providers.reduce((providers, provider, currentIndex) => {
      if (!provider) {
        return;
      }
      const providerAccountDTO = provider.providerAccountDTO;

      const phoneNo = providerAccountDTO.locationPhone
        ? providerAccountDTO.locationPhone : 'Not Found';
      const faxNo = providerAccountDTO.locationFax
        ? providerAccountDTO.locationFax : 'Not Found';
      const faxNoConf = providerAccountDTO.faxConfirmedDate ? 'Yes' : 'No';

      providers.push({
        value: { currentIndex },
        label: `${providerAccountDTO.providerName || ''}, ${providerAccountDTO.physicalStreet || ''}, ${providerAccountDTO.physicalCity || ''},
                ${providerAccountDTO.physicalState || ''} ${providerAccountDTO.physicalZip || ''},
                ${'PHONE: '}${phoneNo}, ${' FAX: '} ${faxNo}, ${' FAX# CONFIRMED: '} ${faxNoConf}`
      });

      return providers;
    }, []);
  }

  private buildProviderSelectItemListForExternalUser() {
    return (this.providers as any).reduce((providers, provider, currentIndex) => {
      providers.push({
        value: {
          currentIndex,
          npi: provider.npi
        },
        label: `${provider.providerName || ''}, ${provider.address || ''}, ${provider.city || ''},
                ${provider.state || ''} ${provider.zipCode || ''},` +
                ` ${' PHONE: '} ${provider.phoneNumber || ''},${' FAX: '} ${provider.faxNumber || ''},${' FAX# CONFIRMED: '} ${provider.faxNumberConfirmed || ''}`
      });

      return providers;
    }, []);
  }

}
